// extracted by mini-css-extract-plugin
var _1 = "i7KD7__footer";
var _2 = "i7KD7__footerFooter";
var _3 = "i7KD7__textarea";
export { _1 as "footer", _2 as "footerFooter", _3 as "textarea" }
